module.exports = __webpack_public_path__ + "img/exit.7a273cce.png";